import { memo, MouseEvent, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import * as imagePreviewActions from '@/shared/modules/imagePreview/actions';

import Button from '@/shared/components/button/Button';

import type { ImagePreviewData } from '@/shared/modules/imagePreview/types';

interface ImagePreviewModalProps {
	open: boolean;
	imageSrc: string | null;
	setImagePreviewModal: (data: ImagePreviewData) => void;
}

const ImagePreviewModal = ({ open, imageSrc, setImagePreviewModal }: ImagePreviewModalProps) => {
	const imageNode = useRef<HTMLImageElement>(null);
	const [isModalShowing, setIsModalShowing] = useState(false);

	const handleClose = () => {
		setIsModalShowing(false);
		window.setTimeout(() => {
			setImagePreviewModal({ open: false });
		}, 200);
	};

	const handleClickOutside = (e: MouseEvent<HTMLDivElement>) => {
		if (open && imageNode.current?.contains(e.target as Node)) {
			return;
		}

		handleClose();
	};

	useEffect(() => {
		if (!open) {
			setIsModalShowing(false);
			return;
		}

		const timerId = window.setTimeout(() => {
			setIsModalShowing(true);
		}, 200);

		return () => {
			window.clearTimeout(timerId);
		};
	}, [open]);

	if (!open) {
		return null;
	}

	return (
		<div
			className={classNames('media-modal image-preview', {
				open: isModalShowing,
			})}
			onClick={handleClickOutside}
		>
			<div className="media-modal-backdrop" />
			<div className="container media-modal-wrap">
				<Button
					className="media-modal-close-btn"
					type="close"
					iconName="icon-close"
					small
					onClick={handleClose}
				/>
				<img ref={imageNode} className="preview" src={imageSrc || ''} alt="preview" />
			</div>
		</div>
	);
};

function mapStateToProps({ imagePreviewReducer }: any) {
	return {
		open: imagePreviewReducer.open,
		imageSrc: imagePreviewReducer.imageSrc,
	};
}

const mapDispatchToProps = {
	setImagePreviewModal: imagePreviewActions.setImagePreviewModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(ImagePreviewModal));
